import { Link, useParams } from "react-router-dom";
import { useAuth } from "../../context/Auth";

const EventPaymentSuccess = () => {
  const { eventName } = useParams();
  const { user } = useAuth();

  return (
    <>
      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 ">
        <div className="card-body d-flex align-items-center p-0">
          <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900 align-item-center d-flex">
            <i className="fa-sharp fa-solid fa-circle-check font-xxl mr-11 text-share" />
            EVENT PAYMENT CONFIRMATION
          </h2>
        </div>
      </div>

      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 membership-payment-success">
        <div className="card-body align-items-center p-0">
          <p>
            Dear <strong>{user?.user?.first_name}</strong>,
          </p>
          <p>
            Entry Fee payment confirmed.
            {/* {eventName ? `for ${eventName} contest` : ""}. You can view your
            Entry details any time in <strong>Events</strong> under{" "}
            <strong>
              <Link to="/view-events">View Events</Link>
            </strong> */}
          </p>
          {/* <p className="text-red">PLEASE READ THESE 5 POINTS:</p> */}

          <ul style={{ margin: "20px 50px", }}>
            <li style={{ listStyle: "disc inside" }}>
              You can view your
              Entry details any time in <strong>Events</strong> under{" "}
              <strong>
                <Link to="/view-events">View Entry</Link>
              </strong>
            </li>
            <li style={{ listStyle: "disc inside" }}>
              You can keep editing, make more payments or withdraw your entry in <strong>
                <Link to="/pay-events">Edit / Pay Entry</Link>
              </strong>
            </li>
            <li style={{ listStyle: "disc inside" }}>
              The invoice for your paid Entry Fees can be downloaded in   <strong>
                <Link to="/invoices">Invoices</Link>
              </strong> under <strong>
                <Link to="/subscription-status">Membership</Link>
              </strong>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default EventPaymentSuccess;
